import { render, staticRenderFns } from "./PropertyCard.vue?vue&type=template&id=61341da6"
import script from "./PropertyCard.vue?vue&type=script&lang=ts"
export * from "./PropertyCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports